<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title"> 학자금신청 </v-col>
    </v-row>

    <div class="overflow-y-auto">
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in schClsfiCdList"
            :key="i"
            class="gntType-item"
          >
            <v-list-item-content @click="selectMenu(item)">
              <v-list-item-title>
                <span class="time">{{ item.codeNm }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import routerNames from '@/const/routerConstants';
import { getBenImplGenList, getSchClsfiCd, getEdusAppDetTgtInfoList } from '@/api/workStatus';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    schClsfiCdList: [],
  }),

  computed: {
    ...mapGetters([
      'GET_USER_DATA',
    ]),

  },

  methods: {
    /* 신청서 선택 */
    selectMenu(item) {
      this.$store.commit('schClsfiCd', item.code);
      this.$router.push(routerNames.EdusAppSub);
    },
  },

  async mounted() {
    let params = {
      searchYear: dayjs().format('YYYY'),
      searchBenGenBizCd: 'ED', //학자금 신청기간
    };

    let response = await getBenImplGenList(params);

    if (
      dayjs().format('YYYYMMDD') <= response.data.data.applSYmd ||
      dayjs().format('YYYYMMDD') >= response.data.data.applEYmd
    ) {
      alert(
        '학자금 신청 기간이 아닙니다(' +
          response.data.data.applSYmd +
          ' ~ ' +
          response.data.data.applEYmd +
          ')',
      );
      this.$router.go(-1);
      return;
    }

    response = await getSchClsfiCd(params);
    this.schClsfiCdList = response.data.data;

    this.$store.commit('SET_PARAMS', []);
    this.$store.commit('SET_FILE_SEQ', '');

    params = {
      searchApplSabun: this.GET_USER_DATA.ssnSabun,
      searchApplYmd: dayjs().format('YYYYMMDD'),
    };

    response = await getEdusAppDetTgtInfoList(params);


    if(response.data.data.length === 0 ) {
      alert('대상자가 없습니다');
      this.$router.go(-1);
      return;
    }

    for(let i=0; i<response.data.data.length; i++) {
        if((response.data.data[i].famCd != '20' && response.data.data[i].famCd != '21')) {
          alert('대상자가 없습니다');
          this.$router.go(-1);
          return;
        }
    }

  },
};
</script>

<style></style>
